import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useContext } from "react";
import { AppContext } from "../context/app";
import { getQuicksightEmbedUrl, GetReportResult } from "./quicksightApi";

export function useQuicksightEmbedUrl(
  dashboardId?: string,
  options?: UseQueryOptions<GetReportResult>,
) {
  const app = useContext(AppContext);

  return useQuery({
    ...options,
    queryKey: ["quicksight-embed-url", dashboardId],
    queryFn: () =>
      getQuicksightEmbedUrl({
        clientUuid: app.client?.uuid,
        dashboardId: dashboardId,
      }),
  });
}
